import { useContextStore } from '../../stores/useContextStore';
import { useConfigStore } from '../../stores/useConfigStore';
import { getServices } from '~/db/services';
import type { EventAssociatedModel } from '~/types/adamTypes';

export const useAppEvent = (
  associatedModel: EventAssociatedModel,
  contentId?: string | null,
  libraryBookId?: string | null
) => {
  const { $db } = useNuxtApp();

  const profile = useProfileStore();

  const config = useConfigStore();

  const lastEventCreated = ref<AppEventSchema>(null);

  const { appEventsService } = getServices($db);

  const setContentId = (id: string) => {
    contentId = id;
  };

  const createEvent = async (
    eventType: string,
    eventData: any
  ): Promise<void> => {
    const context = useContextStore();
    const runtimeConfig = useRuntimeConfig();
    if (!context.isLoggedIn) return;
    const event: AppEventSchema = {
      associatedModel,
      eventType,
      eventData,
      eventDate: new Date().toISOString(),
      appVersion: runtimeConfig.public.appVersion,
      member: context.memberId,
      appId: config.appId,
      isWeb: true,
      appOS: 'web',
    };

    if (profile?.levelOfEducationId != null) {
      eventData.LevelOfEducation = profile?.levelOfEducationId;
    }

    if (profile?.currentDegree != null) {
      eventData.currentDegree = profile?.currentDegree;
    }

    event.contentId = contentId || 'noContentId';

    if (libraryBookId) event.libraryBookId = libraryBookId;

    globalThis.$logger.info(
      'useAppEvent ::: createEvent :',
      event.associatedModel,
      event.eventType,
      event
    );
    lastEventCreated.value = event;

    await appEventsService.put(event);
  };
  return {
    lastEventCreated,
    createEvent,
    setContentId,
  };
};
